"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'reports.shared.title': '共享对话',
    'reports.shared.description': '查看其他用户与您共享的对话',
    'reports.shared.failedToLoad': '无法加载共享对话',
    'reports.shared.retryButton': '重试',
    'reports.shared.empty.title': '无共享对话',
    'reports.shared.empty.description': '您还没有其他用户共享的对话。',
    'reports.shared.createdAt': '创建时间',
    'reports.shared.lastActivity': '最后活动',
    'reports.shared.model': 'AI模型',
    'reports.shared.unknownModel': '未知模型',
    'reports.shared.unknownUser': '未知用户',
    'reports.shared.viewButton': '查看',
    'reports.shared.sharedWith': '共享给',
    'reports.shared.noUsers': '无用户',
};
